import { render, staticRenderFns } from "./organization_fwd.vue?vue&type=template&id=a90cbc04&scoped=true&"
import script from "./organization_fwd.vue?vue&type=script&lang=js&"
export * from "./organization_fwd.vue?vue&type=script&lang=js&"
import style0 from "./organization_fwd.vue?vue&type=style&index=0&id=a90cbc04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a90cbc04",
  null
  
)

export default component.exports